var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "color-picker-tabs-component" }, [
    _c("div", { staticClass: "color-picker-tabs" }, [
      _c(
        "div",
        {
          staticClass: "color-picker-tab",
          class: { "color-picker-tab-active": _vm.isFontColorTabActive },
          on: {
            click: function ($event) {
              return _vm.onColorTabClick("font")
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("views.editorTextOptions.colorPickerTabs.font")))]
      ),
      _c(
        "div",
        {
          staticClass: "color-picker-tab",
          class: { "color-picker-tab-active": _vm.isBackgroundColorTabActive },
          on: {
            click: function ($event) {
              return _vm.onColorTabClick("background")
            },
          },
        },
        [
          _vm._v(
            _vm._s(_vm.$t("views.editorTextOptions.colorPickerTabs.background"))
          ),
        ]
      ),
    ]),
    _c(
      "div",
      { staticClass: "color-picker-container" },
      [
        _c("ColorPickerComponent", {
          attrs: {
            canvas: _vm.computedCanvas,
            large: true,
            magnification: 10,
            transparent: _vm.isBackgroundColorTabActive,
            value: _vm.computedColor,
          },
          on: {
            change: _vm.onColorChange,
            "eye-dropper-end": _vm.onEyeDropperEnd,
            "eye-dropper-start": _vm.onEyeDropperStart,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }